import React from 'react';
import PropTypes from 'prop-types';
import { EachAnswer } from '../QuizPageStyles.styles';

const Answer = ({ selected, answer, id, checkAnswer }) => {
  return (
    <EachAnswer className={selected === answer ? 'selectedAnswer' : ''}>
      <label htmlFor={`answer-${id}-${answer}`}>
        <input
          type="radio"
          id={`answer-${id}-${answer}`}
          name={`answer-${id}`}
          value={answer}
          onClick={checkAnswer}
        />
        {answer}
      </label>
    </EachAnswer>
  );
};
Answer.propTypes = {
  selected: PropTypes.string,
  answer: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checkAnswer: PropTypes.func,
};

export default Answer;
